import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

// MUI imports
import {
  Grid,
  TextField,
  Typography,
} from "@mui/material";


const DatePickerWrapper = ({ valDate, setValDate }) => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [endDateErrors, setEndDateErrors] = useState({
    hasError: false,
    showError: false,
    errorText: "",
  });

  const [startDateErrors, setStartDateErrors] = useState({
    hasError: false,
    showError: false,
    errorText: "",
  });

  function handleDateOnChange(dates) {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  }

  function validateDate(state) {
    if (state === null) {
      return false;
    } else if (state === "") {
      return false;
    } else {
      return true;
    }
  }

  useEffect(() => {
    if (valDate.performCheck) {
      const sdClear = validateDate(startDate);
      const edClear = validateDate(endDate);

      if (!edClear) {
        setEndDateErrors({
          hasError: true,
          showError: true,
          errorText: "Please input a valid date",
        });
      } else {
        setEndDateErrors({
          hasError: false,
          showError: false,
          errorText: "",
        });
      }

      if (!sdClear) {
        setStartDateErrors({
          hasError: true,
          showError: true,
          errorText: "Please input a valid date",
        });
      } else {
        setEndDateErrors({
          hasError: false,
          showError: false,
          errorText: "",
        });
      }

      setValDate({
        ...valDate,
        performCheck: false,
        checkComplete: true,
        checkPassed: sdClear && edClear,
        startDate: startDate,
        endDate: endDate,
      });
    }
  }, [valDate]);

  return (
    <Grid container direction={"column"} item xs flexWrap={"nowrap"}>
      <Typography variant="body1" sx={{ mt: 1 }}>
        Start & End Date of training
      </Typography>
      <Typography variant="caption" >
        Click on the start and end date from the calendar below
      </Typography>

      <Grid container direction={"row"} marginTop={2} item xs gap={3} flexWrap={"nowrap"}>
        <Grid container item direction={"column"}>
          <DatePicker
            onChange={handleDateOnChange}
            selectsRange
            inline
            selected={startDate}
            startDate={startDate}
            endDate={endDate}
          />
        </Grid>

        <Grid container direction={"column"} item gap={6} justifyContent="center">
          <TextField
            InputProps={{
              readOnly: true,
            }}
            label="Start Date"
            size="small"
            value={startDate?.toDateString()}
            error={startDateErrors.showError && startDateErrors.hasError}
            helperText={startDateErrors.showError && startDateErrors.errorText}
          />

          <TextField
            InputProps={{
              readOnly: true,
            }}
            label="End Date"
            size="small"
            value={endDate?.toDateString()}
            error={endDateErrors.showError && endDateErrors.hasError}
            helperText={endDateErrors.showError && endDateErrors.errorText}
          />
        </Grid>

      </Grid>

    </Grid>
  );
};

export default DatePickerWrapper;